import { canonicalRoles } from '@/auth/roles';
import { resolveRoles } from '@/hooks/usePermission';
import { useAuthStore } from '@/stores/authStore';

/**
 * Who the console is acting as, as ONE string: the signed-in tenant + agent. Captured when a request is SENT and
 * compared when its answer lands - a change in between (a different tenant, a different agent, a logout) means the
 * answer belongs to someone else's session and is dropped. (The conversation store wipes itself on the same change.)
 */
export const scopeKey = (): string => {
  const u = useAuthStore.getState().user;
  return `${u?.tenantId ?? ''}|${u?.agentId ?? ''}`;
};

/** The viewer, read FRESH at the moment of each decision (never captured): staff id + canonical role claims. */
export function readViewer(): { me: string | null; roles: string[] } {
  const { user, token } = useAuthStore.getState();
  return { me: user?.agentId || null, roles: canonicalRoles(resolveRoles(token, user)) };
}

/** The HTTP status of an Axios-shaped failure, if it has one. */
export const httpStatus = (err: unknown): number | undefined =>
  (err as { response?: { status?: number } } | null | undefined)?.response?.status;
